import { Table } from '@octano/global-ui';
import useColumns from '../hooks/useColumns';
import { usePaymentHistorytLoader } from './PaymentHistoryLoader';

function PaymentHistoryTable() {
  const { data, loading } = usePaymentHistorytLoader();

  const onClickDetail = (row: any) => {
    console.log(row);
  };

  const columns = useColumns({
    onClickDetail,
  });

  return (
    <>
      <div className="divider my-4" />
      <Table
        columns={columns}
        data={data?.payments ?? []}
        isLoadingResults={loading}
      />
    </>
  );
}

export default PaymentHistoryTable;
